import React from 'react';

const TermsOfService = () => {
  return (
    <div className="page-legal">
      <div className="container">
        <div className="legal-content">
          <h1 className="heading-1">Terms of Service</h1>
          <p className="legal-updated">Last Updated: January 2025</p>
          
          <p className="body-regular legal-intro">
            Welcome to Glow Health. These Terms of Service govern your use of our website 
            and services. By using our website or submitting information through our forms, 
            you agree to these terms. Please read them carefully.
          </p>

          <section className="legal-section">
            <h2 className="heading-3">Eligibility</h2>
            <p className="body-regular">
              You must be at least 18 years of age to use our website and services. By using 
              our services, you represent that you meet this age requirement and have the 
              legal capacity to enter into these terms.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">Informational Content</h2>
            <p className="body-regular">
              The content on our website is provided for informational and educational purposes 
              only. It is not intended to be, and should not be considered, medical advice. 
              The information presented does not replace a consultation with a qualified 
              healthcare provider.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">No Patient,Provider Relationship Until Review</h2>
            <p className="body-regular">
              Submitting an intake form, booking an appointment, or making a payment does not 
              automatically establish a patient,provider relationship. A patient,provider 
              relationship is only created after your information has been reviewed and accepted 
              by one of our licensed providers, and you have been formally onboarded as a patient.
            </p>
            <p className="body-regular">
              We reserve the right to decline services if we determine that our care is not 
              appropriate for your needs.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">No Emergency Services</h2>
            <p className="body-regular">
              <strong>Glow Health does not provide emergency medical services.</strong> If you 
              are experiencing a medical emergency, please call 911 or go to your nearest 
              emergency room immediately. Our services are designed for non-urgent, ongoing 
              hormone health care and are not equipped to handle emergency situations.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">Payment Terms</h2>
            <p className="body-regular">
              By purchasing a membership or service, you agree to the pricing displayed at 
              the time of purchase. Payments are processed securely through our payment provider.
            </p>
            <ul className="legal-list">
              <li><strong>Membership:</strong> The Glow Health Membership is billed as a one-time payment for the initial consultation and onboarding period</li>
              <li><strong>Refunds:</strong> If you are unsatisfied with your service or unable to proceed, please contact us to discuss your options. Refund eligibility is evaluated on a case-by-case basis</li>
              <li><strong>Cancellations:</strong> You may cancel a scheduled appointment by contacting us at least 24 hours in advance. Late cancellations or no-shows may not be eligible for rescheduling without additional payment</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">SMS Terms & Conditions</h2>
            <p className="body-regular">
              By opting in to receive SMS messages from Glow Health LLC, you agree to receive 
              text messages regarding scheduling, appointment reminders, account updates, and 
              customer support communications.
            </p>
            <p className="body-regular">
              Message frequency may vary. Message and data rates may apply.
            </p>
            <p className="body-regular">
              To opt out at any time, reply STOP to any message. To receive assistance, reply 
              HELP or contact support@myglowhealth.co.
            </p>
            <p className="body-regular">
              Glow Health LLC is not responsible for delayed or undelivered messages. Carrier 
              message and data rates may apply.
            </p>
            <p className="body-regular">
              You must be 18 years or older to use our services.
            </p>
            <p className="body-regular">
              For more information on how we collect and use your data, please review our{' '}
              <a href="/privacy-policy" className="legal-link">Privacy Policy</a>.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">Limitation of Liability</h2>
            <p className="body-regular">
              To the fullest extent permitted by law, Glow Health and its providers, employees, 
              and affiliates shall not be liable for any indirect, incidental, special, 
              consequential, or punitive damages arising from your use of our website or services.
            </p>
            <p className="body-regular">
              Our total liability for any claim arising from these terms or your use of our 
              services shall not exceed the amount you paid for the specific service giving 
              rise to the claim.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">Indemnification</h2>
            <p className="body-regular">
              You agree to indemnify and hold harmless Glow Health, its providers, employees, 
              and affiliates from any claims, damages, or expenses arising from your use of 
              our website or services, your violation of these terms, or your violation of 
              any rights of another party.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">Changes to These Terms</h2>
            <p className="body-regular">
              We may update these Terms of Service from time to time. When we make changes, 
              we will update the effective date at the top of this page. Your continued use 
              of our website or services after changes are posted constitutes your acceptance 
              of the updated terms.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">Governing Law and Jurisdiction</h2>
            <p className="body-regular">
              These Terms of Service are governed by and construed in accordance with the 
              laws of the State of Utah, without regard to conflict of law principles. Any 
              disputes arising from these terms or your use of our services shall be resolved 
              in the state or federal courts located in Utah.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">Contact Us</h2>
            <p className="body-regular">
              If you have questions about these Terms of Service, please contact us at:
            </p>
            <p className="body-regular legal-contact">
              <strong>Email:</strong> support@myglowhealth.co
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
